export default __webpack_public_path__ + "static/media/ellipse-ruler-blue.169a3ed2.svg";